const users = state => state.users
const isLoading = state => state.isLoading
const hasError = state => state.error !== null
const error = state => state.error === '' ? 'Произошла ошибка. Попробуйте еще раз' : state.error
const hasUsers = state => state.users.length > 0
const user = state => state.user
const hasUser = state => state.user !== null

export default {
    users, isLoading, hasError, error, hasUsers, user, hasUser
}
